:host {
  display: contents;
}

th {
  background-color: inherit;
  font: inherit;
  max-width: inherit;
  min-width: inherit;
  padding-block: var(--ld-table-cell-padding-y);
  padding-inline: var(--ld-table-cell-padding-x);
}

.ld-table-header--sortable {
  cursor: pointer;
}

.ld-table-header__sort-buttons {
  display: inline-grid;
  margin: -1.2rem calc(-1 * var(--ld-sp-8)) -1rem var(--ld-sp-6);
  vertical-align: middle;

  ld-button::part(button) {
    min-height: 0;
  }
}
